import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-contactez-nous',
  templateUrl: './contactez-nous.component.html',
  standalone: false,
})
export class ContactezNousComponent implements OnInit {
  @Input() niveauTitre!: 'h2' | 'h4';
  estH2!: boolean;

  ngOnInit(): void {
    this.estH2 = this.niveauTitre === 'h2';
  }
}
